// /opt/isp_erp/frontend/src/components/tickets/CloseCambioEquipoDialog.jsx

import React, { useState, useEffect } from 'react';
import MaterialBuscador from './MaterialBuscador';
import VinetaBuscador from './VinetaBuscador';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Grid,
  Paper,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  InputAdornment,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  FormControlLabel
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  SwapHoriz as SwapHorizIcon,
  Search,
  Clear,
  ExpandMore,
  Inventory,
  LocationOn as LocationIcon,
  MyLocation as MyLocationIcon,
  PhotoCamera as PhotoIcon,
  Download as DownloadIcon,
  CheckCircle as CheckIcon,
  Vignette as VignetteIcon,
  Delete as DeleteIconVignette
} from '@mui/icons-material';
import { ticketsAPI } from '../../api/tickets.api';
import { warehouseAPI } from '../../api/warehouse.api';
import api from '../../api/axios';
import FotoUploader from './FotoUploader';

const CloseCambioEquipoDialog = ({ open, onClose, ticket, onSuccess }) => {
  const [materiales, setMateriales] = useState([]);
  const [nuevoMaterial, setNuevoMaterial] = useState({
    material_id: '',
    cantidad: '1',   // ✅ CAMBIO 1: string
    observaciones: ''
  });
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Estados para éxito y PDF
  const [showSuccess, setShowSuccess] = useState(false);
  const [pdfBase64, setPdfBase64] = useState(null);
  const [ticketNumber, setTicketNumber] = useState('');
  const [ticketId, setTicketId] = useState(null);

  // Estados para fotos
  const [fotosBase64, setFotosBase64] = useState([]);

  // Estados para ubicación
  const [ubicacion, setUbicacion] = useState(null);
  const [obteniendoUbicacion, setObteniendoUbicacion] = useState(false);
  const [errorUbicacion, setErrorUbicacion] = useState('');
  const [usarUbicacion, setUsarUbicacion] = useState(true);

  // Estados para equipos
  const [equiposNuevos, setEquiposNuevos] = useState([]);
  const [equiposViejos, setEquiposViejos] = useState([]);
  const [equiposEnTransito, setEquiposEnTransito] = useState([]);
  const [equiposFiltrados, setEquiposFiltrados] = useState([]);
  const [selectedEquipo, setSelectedEquipo] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [cargandoEquipos, setCargandoEquipos] = useState(false);
  const [expandedEquipos, setExpandedEquipos] = useState(false);

  // Catálogo de materiales
  const [catalogoMateriales, setCatalogoMateriales] = useState([]);
  const [expandedMateriales, setExpandedMateriales] = useState(false);

  // ✅ Estados para viñetas
  const [vinetaNueva, setVinetaNueva] = useState('');
  const [vinetaRetirar, setVinetaRetirar] = useState(false);
  const [vignettesDisponibles, setVignettesDisponibles] = useState([]);
  const [cargandoVignettes, setCargandoVignettes] = useState(false);
  const [customerVineta, setCustomerVineta] = useState('');

  // ✅ Obtener viñeta del cliente
  useEffect(() => {
    if (ticket && ticket.customer_id) {
      api.get(`/customers/${ticket.customer_id}`)
        .then(res => {
          const vineta = res.data?.vineta || '';
          console.log('🏷️ Viñeta del cliente obtenida:', vineta);
          setCustomerVineta(vineta);
        })
        .catch(err => console.error('Error obteniendo viñeta del cliente:', err));
    }
  }, [ticket?.customer_id]);

  // Función para descargar PDF
  const handleDownloadPDF = () => {
    if (!pdfBase64) return;

    try {
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `cambio_equipo_${ticketNumber || ticketId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error descargando PDF:', error);
      setError('Error al descargar el PDF');
    }
  };

  const handleCloseDialog = () => {
    setShowSuccess(false);
    setPdfBase64(null);
    setTicketNumber('');
    setTicketId(null);
    onClose();
  };

  // Función para obtener ubicación
  const obtenerUbicacion = () => {
    if (!navigator.geolocation) {
      setErrorUbicacion('Geolocalización no soportada');
      setUsarUbicacion(false);
      return;
    }

    setObteniendoUbicacion(true);
    setErrorUbicacion('');

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const ubicacionData = {
          latitud: position.coords.latitude,
          longitud: position.coords.longitude,
          precision: position.coords.accuracy
        };
        setUbicacion(ubicacionData);
        setObteniendoUbicacion(false);
      },
      (error) => {
        console.error('Error de geolocalización:', error);
        let mensaje = '';
        switch(error.code) {
          case error.PERMISSION_DENIED:
            mensaje = 'Permiso denegado. Activa la ubicación en tu dispositivo.';
            break;
          case error.POSITION_UNAVAILABLE:
            mensaje = 'No se pudo obtener la ubicación. Verifica tu GPS.';
            break;
          case error.TIMEOUT:
            mensaje = 'Tiempo de espera agotado. Intenta nuevamente.';
            break;
          default:
            mensaje = 'Error al obtener ubicación.';
        }
        setErrorUbicacion(mensaje);
        setObteniendoUbicacion(false);
        setUsarUbicacion(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  // ✅ Función para cargar viñetas disponibles del técnico - CORREGIDA
  const cargarVignettesDisponibles = async () => {
    if (!ticket?.assigned_technician_id) {
      console.warn('⚠️ No hay técnico asignado al ticket');
      return;
    }

    setCargandoVignettes(true);
    try {
      const response = await api.get(`/warehouse/vignettes?tecnico_id=${ticket.assigned_technician_id}`);
      console.log('📦 Response.data:', response.data);

      const data = response.data || [];

      const disponibles = data.filter(v =>
        v.estado === 'ASIGNADO' && v.tecnico_id === ticket.assigned_technician_id
      );

      const vignettesConOrigen = disponibles.map(v => ({
        ...v,
        asignada_a_tecnico: true,
        disponible: true
      }));

      setVignettesDisponibles(vignettesConOrigen);
      console.log('🏷️ Viñetas disponibles seteadas:', vignettesConOrigen);
    } catch (error) {
      console.error('❌ Error cargando viñetas:', error);
      if (error.response?.status === 401) {
        console.error('🔴 Token inválido o expirado');
      }
      setVignettesDisponibles([]);
    } finally {
      setCargandoVignettes(false);
    }
  };

  // Cargar equipos en tránsito del técnico asignado al ticket
  useEffect(() => {
    if (open && ticket) {
      setShowSuccess(false);
      setPdfBase64(null);
      setTicketNumber('');

      cargarEquiposDelTecnico();
      cargarMateriales();
      cargarVignettesDisponibles();

      if (usarUbicacion) {
        obtenerUbicacion();
      }

      if (ticket.materials_used?.equipos_viejos) {
        setEquiposViejos(ticket.materials_used.equipos_viejos);
      } else if (ticket.old_equipment_sn) {
        setEquiposViejos([{ sn: ticket.old_equipment_sn, motivo: '' }]);
      }

      if (ticket.materials_used?.equipos_nuevos) {
        setEquiposNuevos(ticket.materials_used.equipos_nuevos);
      }
    }
  }, [open, ticket]);

  // Filtrar equipos según búsqueda
  useEffect(() => {
    if (searchTerm && equiposEnTransito.length > 0) {
      const filtrados = equiposEnTransito.filter(e =>
        e.sn?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.modelo?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setEquiposFiltrados(filtrados);
    } else {
      setEquiposFiltrados(equiposEnTransito);
    }
  }, [searchTerm, equiposEnTransito]);

  const cargarMateriales = async () => {
    try {
      const response = { data: [] }; // el buscador consulta al servidor: ya no se descarga el catálogo completo
      setCatalogoMateriales(response.data || []);
    } catch (error) {
      console.error('Error cargando materiales:', error);
    }
  };

  const cargarEquiposDelTecnico = async () => {
    setCargandoEquipos(true);
    setError('');
    try {
      const tecnicoIdAsignado = ticket.assigned_technician_id;

      if (!tecnicoIdAsignado) {
        setError('El ticket no tiene técnico asignado');
        setCargandoEquipos(false);
        return;
      }

      const response = await warehouseAPI.listarEquipos({
        estado: 'EN_TRANSITO'
      });

      const todosEquipos = response?.data || [];

      const equiposDelTecnico = todosEquipos.filter(equipo => {
        const poseedorTipo = equipo.poseedor?.tipo;
        const poseedorId = equipo.poseedor?.id;
        return poseedorTipo &&
               (poseedorTipo === 'Técnico' || poseedorTipo === 'tecnico') &&
               parseInt(poseedorId) === parseInt(tecnicoIdAsignado);
      });

      setEquiposEnTransito(equiposDelTecnico);
      setEquiposFiltrados(equiposDelTecnico);

      if (equiposDelTecnico.length === 0 && ticket.status !== 'cerrado') {
        setError(`No se encontraron equipos en tránsito para el técnico ID ${tecnicoIdAsignado}`);
      } else if (equiposDelTecnico.length === 0 && ticket.status === 'cerrado') {
        console.log('ℹ️ El ticket ya está cerrado, los equipos ya fueron instalados');
        setError('');
      }
    } catch (error) {
      console.error('Error cargando equipos:', error);
      setError(error?.response?.data?.detail || 'Error al cargar los equipos disponibles');
    } finally {
      setCargandoEquipos(false);
    }
  };

  const agregarEquipoViejo = () => {
    const sn = prompt('Ingrese el número de serie del equipo viejo a retirar:');
    if (sn && sn.trim()) {
      if (equiposViejos.some(e => e.sn === sn.trim())) {
        setError('Este equipo ya ha sido agregado');
        return;
      }
      const motivoEquipo = prompt('Motivo del retiro (opcional):');
      setEquiposViejos([...equiposViejos, {
        sn: sn.trim(),
        motivo: motivoEquipo || ''
      }]);
    }
  };

  const eliminarEquipoViejo = (index) => {
    setEquiposViejos(equiposViejos.filter((_, i) => i !== index));
  };

  const agregarEquipo = () => {
    if (!selectedEquipo) {
      setError('Seleccione un equipo');
      return;
    }
    if (equiposNuevos.some(e => e.sn === selectedEquipo.sn)) {
      setError('Este equipo ya ha sido agregado');
      return;
    }
    setEquiposNuevos([...equiposNuevos, {
      sn: selectedEquipo.sn,
      tipo: 'ONU',
      modelo: selectedEquipo.modelo || 'DESCONOCIDO'
    }]);
    setSelectedEquipo(null);
    setSearchTerm('');
    setError('');
  };

  const eliminarEquipo = (index) => {
    setEquiposNuevos(equiposNuevos.filter((_, i) => i !== index));
  };

  const actualizarTipoEquipo = (index, tipo) => {
    const nuevos = [...equiposNuevos];
    nuevos[index].tipo = tipo;
    setEquiposNuevos(nuevos);
  };

  // ✅ CAMBIO 3: agregarMaterial corregido
  // Selección desde el buscador de materiales: registra el material elegido
  const seleccionarMaterial = (item) => {
    if (!item) {
      setNuevoMaterial(prev => ({ ...prev, material_id: '' }));
      return;
    }
    setCatalogoMateriales(prev => prev.some(m => m.id === item.material_id)
      ? prev
      : [...prev, { id: item.material_id, codigo: item.codigo, nombre: item.nombre, unidad: item.unidad }]);
    setNuevoMaterial(prev => ({ ...prev, material_id: item.material_id }));
  };

  const agregarMaterial = () => {
    if (!nuevoMaterial.material_id) {
      setError('Seleccione un material');
      return;
    }

    // ✅ Convertir a número al agregar
    const cantidadNum = parseInt(nuevoMaterial.cantidad, 10);

    if (isNaN(cantidadNum) || cantidadNum < 1) {
      setError('Ingrese una cantidad válida (mayor o igual a 1)');
      return;
    }

    const materialInfo = catalogoMateriales.find(m => m.id === nuevoMaterial.material_id);
    if (!materialInfo) {
      setError('Material no encontrado');
      return;
    }

    const nuevoMaterialObj = {
      nombre: materialInfo.nombre,
      material_id: materialInfo.id,
      cantidad: cantidadNum,
      observaciones: nuevoMaterial.observaciones || ''
    };

    console.log('✅ Agregando material:', nuevoMaterialObj);
    console.log('📦 Materiales antes de agregar:', materiales);

    setMateriales([...materiales, nuevoMaterialObj]);
    setNuevoMaterial({ material_id: '', cantidad: '1', observaciones: '' });  // ✅ string
    setError('');
  };

  const eliminarMaterial = (index) => {
    setMateriales(materiales.filter((_, i) => i !== index));
  };

  // ==================== handleSubmit CORREGIDO CON VIÑETAS ====================
  const handleSubmit = async () => {
    const vinetaActual = ticket?.vineta || customerVineta;

    if (vinetaRetirar && !vinetaActual) {
      setError('No hay viñeta para retirar');
      return;
    }

    if (vinetaNueva) {
      if (vinetaActual === vinetaNueva) {
        setError('La viñeta ya está asignada al cliente');
        return;
      }
      const vignetteDisponible = vignettesDisponibles.some(v => v.serial === vinetaNueva);
      if (!vignetteDisponible) {
        setError('La viñeta seleccionada no está disponible');
        return;
      }
    }

    console.log('📦 MATERIALES FINALES antes de enviar:', JSON.stringify(materiales, null, 2));
    console.log('🏷️ Viñeta actual:', vinetaActual);
    console.log('🏷️ Viñeta nueva:', vinetaNueva);
    console.log('🏷️ Retirar viñeta:', vinetaRetirar);


    if (equiposNuevos.length === 0) {
      setError('Debe seleccionar al menos un equipo nuevo a instalar');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let ubicacionData = null;
      if (usarUbicacion && ubicacion) {
        ubicacionData = {
          latitud: ubicacion.latitud,
          longitud: ubicacion.longitud,
          precision: ubicacion.precision
        };
      }

      const equiposViejosFinal = equiposViejos.length > 0
        ? equiposViejos
        : (ticket.materials_used?.equipos_viejos ||
           (ticket.old_equipment_sn ? [{ sn: ticket.old_equipment_sn, motivo: motivo }] : []));

      console.log('📦 MATERIALES antes de enviar:', JSON.stringify(materiales, null, 2));
      console.log('📦 EQUIPOS NUEVOS antes de enviar:', JSON.stringify(equiposNuevos, null, 2));
      console.log('📦 EQUIPOS VIEJOS antes de enviar:', JSON.stringify(equiposViejosFinal, null, 2));
      console.log('🏷️ Viñeta nueva:', vinetaNueva);
      console.log('🏷️ Retirar viñeta:', vinetaRetirar);

      const result = await ticketsAPI.closeCambioEquipoTicket(
        ticket.id,
        equiposViejosFinal,
        equiposNuevos,
        materiales,
        motivo || ticket?.description || 'Cambio de equipo',
        fotosBase64,
        ubicacionData,
        vinetaNueva || undefined,
        vinetaRetirar
      );

      if (result.vineta_cambiada) {
        alert(`✅ Viñeta cambiada exitosamente. Nueva viñeta: ${result.vineta_actual || 'N/A'}`);
      } else if (result.vineta_retirada) {
        alert('✅ Viñeta retirada exitosamente');
      } else if (vinetaNueva || vinetaRetirar) {
        console.warn('⚠️ No se realizó ninguna acción sobre la viñeta');
      }

      if (result.pdf_generado && result.pdf_base64) {
        setPdfBase64(result.pdf_base64);
        setTicketNumber(result.ticket || ticket.ticket_number);
        setTicketId(ticket.id);
      }

      setShowSuccess(true);
      if (onSuccess) onSuccess();

      // Igual que el cierre de retiro: la ventana se cierra sola y se vuelve al ticket
      setTimeout(() => {
        handleCloseDialog();
      }, 2000);

    } catch (err) {
      console.error('Error closing ticket:', err);
      setError(err.response?.data?.detail || 'Error al cerrar el ticket');
      setShowSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  // Pantalla de éxito
  if (showSuccess) {
    return (
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: 'center' }}>
          <CheckIcon sx={{ fontSize: 60, color: 'success.main' }} />
          <Typography variant="h5" color="success.main" sx={{ mt: 1 }}>
            ¡Cambio de Equipo Completado!
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant="body1" gutterBottom>
              Ticket <strong>{ticketNumber || ticket?.ticket_number}</strong> cerrado exitosamente.
            </Typography>
            {pdfBase64 && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadPDF}
                sx={{ mt: 3, mb: 2, px: 4 }}
                fullWidth
              >
                📄 Descargar PDF del Cambio
              </Button>
            )}
            {!pdfBase64 && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                El PDF se generará automáticamente.
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button variant="outlined" onClick={handleCloseDialog} size="large">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (!ticket) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Completar Cambio de Equipo
        <Typography variant="body2" color="text.secondary">
          Ticket: {ticket.ticket_number} - {ticket.title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Alert severity="warning" sx={{ mb: 2 }}>
                <strong>Equipo(s) a RETIRAR:</strong>{' '}
                {equiposViejos.length > 0
                  ? equiposViejos.map(e => e.sn).join(', ')
                  : (ticket.materials_used?.equipos_viejos?.map(e => e.sn).join(', ') ||
                     ticket.old_equipment_sn || 'No especificado')}
              </Alert>
            </Grid>
            <Grid item xs={12} md={6}>
              <Alert severity="success" sx={{ mb: 2 }}>
                <strong>Equipo(s) nuevo(s) a instalar:</strong> {equiposNuevos.length} seleccionados
              </Alert>
            </Grid>
          </Grid>
          <Alert severity="info">
            <strong>🔄 Proceso de Cambio:</strong>
            <br />• Seleccione los equipos nuevos que instalará (deben estar en tránsito con el técnico asignado)
            <br />• Los equipos viejos cambiarán a estado <strong>RETIRO_PENDIENTE</strong>
            <br />• Los equipos nuevos cambiarán a estado <strong>INSTALADO</strong>
            <br />• El técnico deberá devolver los equipos viejos a bodega
            <br />• Los materiales se descontarán del stock del técnico
            <br />• Opcionalmente puede cambiar la viñeta del cliente
          </Alert>
        </Box>

        {/* FOTOS */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <PhotoIcon color="primary" />
            Evidencia Fotográfica
          </Typography>
          <FotoUploader onFotosChange={setFotosBase64} maxFotos={9} />
        </Box>

        {/* UBICACIÓN */}
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationIcon color="primary" />
              Ubicación del Cambio
            </Typography>
            <FormControlLabel
              control={<Switch checked={usarUbicacion} onChange={(e) => setUsarUbicacion(e.target.checked)} size="small" />}
              label="Guardar ubicación"
            />
          </Box>
          {usarUbicacion && (
            <>
              {!ubicacion && !obteniendoUbicacion && !errorUbicacion && (
                <Button size="small" variant="outlined" startIcon={<MyLocationIcon />} onClick={obtenerUbicacion} fullWidth>
                  Obtener ubicación actual
                </Button>
              )}
              {obteniendoUbicacion && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={20} />
                  <Typography variant="body2">Obteniendo ubicación...</Typography>
                </Box>
              )}
              {errorUbicacion && (
                <Alert severity="warning" size="small" sx={{ mt: 1 }}>{errorUbicacion}</Alert>
              )}
              {ubicacion && (
                <Alert severity="success" sx={{ mt: 1 }} icon={<MyLocationIcon />}>
                  <Typography variant="caption" display="block">
                    Lat: {ubicacion.latitud.toFixed(6)} | Lng: {ubicacion.longitud.toFixed(6)}
                  </Typography>
                  {ubicacion.precision && (
                    <Typography variant="caption" display="block" color="text.secondary">
                      Precisión: ±{Math.round(ubicacion.precision)}m
                    </Typography>
                  )}
                </Alert>
              )}
            </>
          )}
        </Paper>

        {/* EQUIPOS VIEJOS EDITABLES */}
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Inventory sx={{ mr: 1, verticalAlign: 'middle' }} />
              Equipos VIEJOS a Retirar ({equiposViejos.length})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={agregarEquipoViejo} sx={{ mb: 2 }}>
              Agregar equipo viejo
            </Button>
            {equiposViejos.length === 0 ? (
              <Typography variant="caption" color="text.secondary">
                No hay equipos viejos registrados. Use el botón para agregar o se tomarán los del ticket.
              </Typography>
            ) : (
              equiposViejos.map((eq, idx) => (
                <Paper key={idx} sx={{ p: 2, mb: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography fontWeight="bold">{eq.sn}</Typography>
                      {eq.motivo && (
                        <Typography variant="caption" color="text.secondary" display="block">
                          Motivo: {eq.motivo}
                        </Typography>
                      )}
                    </Box>
                    <IconButton size="small" color="error" onClick={() => eliminarEquipoViejo(idx)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Paper>
              ))
            )}
            {equiposViejos.length === 0 && ticket.materials_used?.equipos_viejos && (
              <Alert severity="info" sx={{ mt: 1 }}>
                Equipos viejos del ticket: {ticket.materials_used.equipos_viejos.map(e => e.sn).join(', ')}
              </Alert>
            )}
          </AccordionDetails>
        </Accordion>

        {/* Selección de equipos nuevos */}
        <Accordion expanded={expandedEquipos} onChange={() => setExpandedEquipos(!expandedEquipos)}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="h6">
              <Inventory sx={{ mr: 1, verticalAlign: 'middle' }} />
              Equipos NUEVOS a Instalar ({equiposNuevos.length})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="caption" color="warning.main" sx={{ mb: 2, display: 'block' }}>
              Solo se muestran equipos que tiene el técnico asignado (EN_TRANSITO)
            </Typography>

            <TextField
              fullWidth
              placeholder="Buscar equipo por SN o modelo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              size="small"
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchTerm('')}><Clear /></IconButton>
                  </InputAdornment>
                )
              }}
            />

            {cargandoEquipos ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}><CircularProgress /></Box>
            ) : (
              <>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Equipos disponibles:</Typography>
                <List dense sx={{ maxHeight: 200, overflow: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, mb: 2 }}>
                  {equiposFiltrados.length === 0 ? (
                    <ListItem>
                      <ListItemText
                        primary="No hay equipos en tránsito disponibles para este técnico"
                        secondary="Asegúrate de que el técnico tenga equipos asignados en tránsito"
                      />
                    </ListItem>
                  ) : (
                    equiposFiltrados.map(equipo => (
                      <ListItem
                        key={equipo.id}
                        button
                        onClick={() => setSelectedEquipo(equipo)}
                        selected={selectedEquipo?.id === equipo.id}
                        disabled={equiposNuevos.some(e => e.sn === equipo.sn)}
                        sx={{
                          '&:hover': { bgcolor: '#e8f5e9' },
                          bgcolor: selectedEquipo?.id === equipo.id ? '#e8f5e9' : 'transparent'
                        }}
                      >
                        <ListItemText
                          primary={
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography fontWeight="bold">{equipo.sn}</Typography>
                              <Chip label={equipo.modelo || 'Sin modelo'} size="small" variant="outlined" />
                            </Box>
                          }
                          secondary={`Estado: EN_TRANSITO`}
                        />
                        {equiposNuevos.some(e => e.sn === equipo.sn) && (
                          <Chip label="Ya agregado" color="success" size="small" />
                        )}
                      </ListItem>
                    ))
                  )}
                </List>

                {selectedEquipo && !equiposNuevos.some(e => e.sn === selectedEquipo.sn) && (
                  <Paper sx={{ p: 2, mb: 2, bgcolor: '#e8f5e9', border: '1px solid #4caf50' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Box>
                        <Typography variant="subtitle2" color="success.main">Equipo seleccionado:</Typography>
                        <Typography variant="body1" fontWeight="bold">{selectedEquipo.sn}</Typography>
                        <Typography variant="caption">{selectedEquipo.modelo || 'Modelo no especificado'}</Typography>
                      </Box>
                      <Button variant="contained" onClick={agregarEquipo} startIcon={<AddIcon />} size="small">
                        Agregar a la lista
                      </Button>
                    </Box>
                  </Paper>
                )}

                <Divider sx={{ my: 1 }} />
                <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                  Equipos seleccionados ({equiposNuevos.length}):
                </Typography>
                {equiposNuevos.length === 0 ? (
                  <Typography variant="caption" color="text.secondary">Ningún equipo seleccionado</Typography>
                ) : (
                  equiposNuevos.map((eq, idx) => (
                    <Paper key={idx} sx={{ p: 2, mb: 2 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography fontWeight="bold">{eq.sn}</Typography>
                        <IconButton size="small" color="error" onClick={() => eliminarEquipo(idx)}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography variant="caption">{eq.modelo}</Typography>
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <InputLabel>Tipo</InputLabel>
                          <Select
                            value={eq.tipo}
                            onChange={(e) => actualizarTipoEquipo(idx, e.target.value)}
                            label="Tipo"
                          >
                            <MenuItem value="ONU">ONU</MenuItem>
                            <MenuItem value="ROUTER">Router</MenuItem>
                            <MenuItem value="BRIDGE">Bridge</MenuItem>
                            <MenuItem value="SWITCH">Switch</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Paper>
                  ))
                )}
              </>
            )}
          </AccordionDetails>
        </Accordion>

        {/* Materiales Utilizados */}
        <Accordion expanded={expandedMateriales} onChange={() => setExpandedMateriales(!expandedMateriales)} sx={{ mt: 2 }}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="h6">
              <Inventory sx={{ mr: 1 }} />
              Materiales Utilizados ({materiales.length}) - opcional
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
              <Grid item xs={12} md={5}>
                <MaterialBuscador
                  ticketId={ticket?.id}
                  tecnicoId={ticket?.assigned_technician_id}
                  modo="stock"
                  value={nuevoMaterial.material_id}
                  onSelect={seleccionarMaterial}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                {/* ✅ CAMBIO 2: onChange simple + onFocus select */}
                <TextField
                  fullWidth
                  type="number"
                  label="Cantidad"
                  size="small"
                  value={nuevoMaterial.cantidad}
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor === '' || /^\d*$/.test(valor)) {
                      setNuevoMaterial({ ...nuevoMaterial, cantidad: valor });
                    }
                  }}
                  onFocus={(e) => e.target.select()}
                  inputProps={{ min: 1, step: 1 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  size="small"
                  value={nuevoMaterial.observaciones}
                  onChange={(e) => setNuevoMaterial({ ...nuevoMaterial, observaciones: e.target.value })}
                  placeholder="Ej: Conector SC/APC"
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={agregarMaterial}
                  startIcon={<AddIcon />}
                  disabled={!nuevoMaterial.material_id}
                >
                  Agregar
                </Button>
              </Grid>
            </Grid>

            {materiales.length > 0 && (
              <List sx={{ mb: 2 }}>
                <Divider />
                {materiales.map((mat, idx) => (
                  <React.Fragment key={idx}>
                    <ListItem>
                      <ListItemText
                        primary={`${mat.nombre} x${mat.cantidad}`}
                        secondary={mat.observaciones || 'Sin observaciones'}
                      />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" onClick={() => eliminarMaterial(idx)} size="small">
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
            )}
          </AccordionDetails>
        </Accordion>

        {/* ✅ SECCIÓN DE VIÑETA PARA CAMBIO DE EQUIPO - CORREGIDA */}
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <VignetteIcon color="warning" />
          Gestión de Viñeta (Opcional)
        </Typography>

        {(() => {
          const vinetaActual = ticket?.vineta || customerVineta || 'Sin viñeta asignada';
          const hayVineta = vinetaActual !== 'Sin viñeta asignada';
          return (
            <Alert severity="info" sx={{ mb: 2 }}>
              <strong>🏷️ Viñeta actual:</strong> {vinetaActual}
              {ticket?.customer_name && ` (Cliente: ${ticket.customer_name})`}
              {hayVineta && (
                <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                  {ticket?.vineta ? 'Viñeta registrada en el ticket' : 'Viñeta obtenida del cliente'}
                </Typography>
              )}
            </Alert>
          );
        })()}

        <Grid container spacing={2} alignItems="center">
          {/* ✅ Opción 1: Retirar viñeta */}
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={vinetaRetirar}
                  onChange={(e) => {
                    setVinetaRetirar(e.target.checked);
                    if (e.target.checked) {
                      setVinetaNueva('');
                    }
                  }}
                  color="error"
                  disabled={!ticket?.vineta && !customerVineta}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <DeleteIconVignette color={vinetaRetirar ? 'error' : 'disabled'} />
                  <Typography variant="body2">
                    Retirar viñeta (volverá a BODEGA)
                  </Typography>
                  {!ticket?.vineta && !customerVineta && (
                    <Chip label="Sin viñeta" size="small" color="warning" />
                  )}
                </Box>
              }
            />
            {!ticket?.vineta && !customerVineta && (
              <Typography variant="caption" color="text.secondary" sx={{ ml: 7 }}>
                No hay viñeta para retirar
              </Typography>
            )}
          </Grid>

          {/* ✅ Opción 2: Cambiar viñeta - SOLO SELECT (sin switch) */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="body2" sx={{ minWidth: 'fit-content' }}>
                Cambiar a:
              </Typography>
              <VinetaBuscador
                opciones={vignettesDisponibles}
                value={vinetaNueva}
                onChange={(serial) => {
                  setVinetaNueva(serial);
                  if (serial) setVinetaRetirar(false);
                }}
                disabled={vinetaRetirar || cargandoVignettes}
                vacio="Sin cambio"
              />
              {cargandoVignettes && (
                <CircularProgress size={20} />
              )}
            </Box>
            {vignettesDisponibles.length === 0 && !cargandoVignettes && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, ml: 'auto' }}>
                No hay viñetas disponibles para cambiar
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* ✅ Resumen de la acción a realizar */}
        {vinetaRetirar && (ticket?.vineta || customerVineta) && (
          <Alert severity="warning" sx={{ mt: 2, fontSize: '0.8rem' }}>
            ⚠️ Se retirará la viñeta <strong>{ticket?.vineta || customerVineta}</strong> del cliente.
            <br />
            <Typography variant="caption" color="text.secondary">
              La viñeta volverá a estado BODEGA y quedará disponible para futuras asignaciones.
            </Typography>
          </Alert>
        )}

        {vinetaNueva && !vinetaRetirar && (ticket?.vineta || customerVineta) && (
          <Alert severity="success" sx={{ mt: 2, fontSize: '0.8rem' }}>
            ✅ Se cambiará la viñeta de <strong>{ticket?.vineta || customerVineta}</strong> a <strong>{vinetaNueva}</strong>
            <br />
            <Typography variant="caption" color="text.secondary">
              La viñeta actual volverá a BODEGA y la nueva se asignará al cliente.
            </Typography>
          </Alert>
        )}

        {vinetaNueva && !vinetaRetirar && !ticket?.vineta && !customerVineta && (
          <Alert severity="info" sx={{ mt: 2, fontSize: '0.8rem' }}>
            ℹ️ Se asignará la viñeta <strong>{vinetaNueva}</strong> al cliente.
            <br />
            <Typography variant="caption" color="text.secondary">
              El cliente no tiene viñeta asignada actualmente.
            </Typography>
          </Alert>
        )}

        {!vinetaNueva && !vinetaRetirar && (ticket?.vineta || customerVineta) && (
          <Alert severity="info" sx={{ mt: 2, fontSize: '0.8rem' }}>
            ℹ️ La viñeta actual <strong>{ticket?.vineta || customerVineta}</strong> se mantendrá sin cambios.
          </Alert>
        )}

        <TextField
          fullWidth
          label="Motivo del Cambio (opcional)"
          multiline
          rows={2}
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          placeholder="Ej: Equipo dañado por tormenta, actualización a GPON, mejora de velocidad..."
          sx={{ mt: 2, mb: 2 }}
        />

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="info"
          disabled={loading || equiposNuevos.length === 0}
          startIcon={loading ? <CircularProgress size={20} /> : <SwapHorizIcon />}
        >
          {loading ? 'Cerrando...' : 'Completar Cambio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseCambioEquipoDialog;
